import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { handleChange, handleSubmit } from "../../controller/JobRoleController/CreateJobRoleController";
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";

function CreateJobRole({ jobRole, onClose, onSuccess }) {
    const { t } = useTranslation();
    const [formData, setFormData] = useState({ JobRole: '' });
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const { theme, toggleTheme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme == "dark") {
        accordTheme = "accordion-header-dark";
    }

    useEffect(() => {
        if (jobRole) {
            setFormData({
                JobRole: jobRole.JobRole
            });
        } else {
            setFormData({ JobRole: '' }); // Clear form data when switching to add mode
        }
    }, [jobRole]);

    const handleFieldChange = (event) => {
        handleChange(event, formData, setFormData);
    };

    const handleFormSubmit = async (event) => {
        event.preventDefault(); // Prevent default form submission
        if (jobRole) {
            formData.ID = jobRole.ID;
        } else {
            formData.ID = 0;
        }
        const redirectCallback = () => {
            navigate('/'); // Redirect to the login page
        };
        const redirectUserList = () => {
            navigate('/AdministrationSetting?saved=true');
        };
        const response = await handleSubmit(event, formData, setFormData, setErrors);
        onSuccess();
    };

    return (
        <div>
            <form onSubmit={handleFormSubmit}>

                <div className="modal fade jobRoleModal show d-block" id="jobRoleModal" tabIndex="-1" aria-labelledby="jobRoleModalLabel" aria-hidden="true" data-backdrop="static">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className={`modal-header ${accordTheme}`}>
                                <h5 className="modal-title" id="largeModalLabel">{jobRole ? "Edit Position" : "Add Position"}</h5>
                                <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close" onClick={onClose}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">

                                <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px", "marginTop": "10px" }}>
                                    <label htmlFor="inputText" className="col-sm-2 col-form-label">Position:</label>
                                    <div className="col-sm-4">
                                        <input type="text" className="form-control" name="JobRole" value={formData.JobRole} onChange={handleFieldChange} />
                                        {errors.JobRole && <div style={{ color: 'red' }}>{errors.JobRole}</div>}
                                    </div>

                                </div>


                            </div>
                            <div className="modal-footer">
                                <button type="submit" className="btn btn-primary">
                                    <i className="icofont-save" aria-hidden="true"> {jobRole ? " Update" : " Save"}</i>
                                </button>
                                <button className="btn btn-secondary" type="button" data-dismiss="modal" aria-label="Close" onClick={onClose}>
                                    <i className="icofont-close" aria-hidden="true"> Close</i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>

        </div>
    );
}

export default CreateJobRole;